<template>
  <div class="index">
    <section class="index__banner">
      <h1>法律人专属的学习平台</h1>
      <ul class="banner__datas">
        <li v-for="data in bannerData" :key="data.desc" class="banner__data">
          <div class="banner__num">{{ data.num | wan }}</div>
          <div class="banner__desc">{{ data.desc }}</div>
        </li>
      </ul>
    </section>
    <section class="index__block">
      <h2 class="block__title">业务提升</h2>
      <div class="block__desc">覆盖众多法律专业领域，帮助法律人业务提升</div>
      <ul class="block__filter-wrapper">
        <ul class="block__filter">
          <li
            v-for="(filter, index) in promoteFilters"
            :key="filter.type" @click="selectPromoteFilters(index)"
            class="block__filter-item"
            :class="{'block__filter-item--active': index === promoteFilterIndex}"
            :analysis-name="'线上课程_首页_业务提升_标签_' + filter.name">
            {{ filter.name }}
          </li>
        </ul>
        <li class="block__all block__filter-item" @click="checkAllPromote">查看全部 <Icon type="ios-arrow-forward" /></li>
      </ul>
      <div class="block__cards-wrapper">
        <ul v-if="promoteList.length !== 0" class="block__cards">
          <li v-for="promote in promoteList" :key="promote.id" class="block__card">
            <PromoteCard :card="promote" :is-login="isLogin" />
          </li>
        </ul>
        <div v-else class="no-course-tip">
          <vui-ico class="ico ibang-schedule" :w="128"></vui-ico>
          <p class="title">精彩内容，敬请期待</p>
        </div>
      </div>
    </section>
    <section class="index__block">
      <h2 class="block__title">市场拓展</h2>
      <div class="block__desc">海量精美课件模板，助力法律人市场拓展</div>
      <ul class="block__filter-wrapper">
        <ul class="block__filter">
          <li
            v-for="(filter, index) in expandFilters"
            :key="filter.name"
            @click="selectExpandFilters(index)"
            class="block__filter-item"
            :class="{'block__filter-item--active': index === expandFilterIndex}"
            :analysis-name="'线上课程_首页_市场拓展_标签_' + filter.name">
            {{ filter.name }}
          </li>
        </ul>
        <li class="block__all block__filter-item" @click="checkAllExpand">查看全部 <Icon type="ios-arrow-forward" /></li>
      </ul>
      <div class="block__cards-wrapper">
        <ul v-if="expandList.length !== 0" class="block__cards">
          <li v-for="expand in expandList" :key="expand.id" class="block__card" >
            <ExpandCard :card="expand" :is-login="isLogin" :is-bind-alpha="isBindAlpha" />
          </li>
        </ul>
        <div v-else class="no-course-tip">
          <vui-ico class="ico ibang-schedule" :w="128"></vui-ico>
          <p class="title">精彩内容，敬请期待</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PromoteCard from './components/PromoteCard.vue'
import ExpandCard from './components/ExpandCard.vue'
import api from '@/api/home.js'
const MAX_CARD_NUM = 8
export default {
  name: 'index',
  components: {
    PromoteCard,
    ExpandCard,
  },
  computed: {
    ...mapState('app', ['isLogin', 'isBindAlpha']),
  },
  data () {
    return {
      bannerData: [],
      promoteFilters: [],
      promoteList: [],
      promoteFilterIndex: 0,

      expandFilters: [],
      expandList: [],
      expandFilterIndex: 0,
    }
  },
  methods: {
    async getBannerData () {
      const data = await api.getBannerData()
      this.bannerData = data
    },
    // 业务提升
    ...{
      // 获取业务提升过滤标签
      async getPromoteFilters () {
        const data = await api.getPromoteFilters()
        this.promoteFilters = data.categoryList.slice(0, MAX_CARD_NUM)
        this.promoteFilters.unshift({
          name: '推荐',
          value: 3,
          isOrder: true,
        })
        this.promoteFilters.unshift({
          name: '最新',
          value: 1,
          isOrder: true,
        })
      },
      // 选择业务提升标签
      selectPromoteFilters (index) {
        this.promoteFilterIndex = index
        this.getPromoteList()
      },
      // 获取业务提升列表
      async getPromoteList () {
        let order = 1
        let type = null
        let filter = this.promoteFilters[this.promoteFilterIndex]
        if (filter.isOrder) {
          order = filter.value
        } else {
          type = filter.type
        }
        const data = await api.getPromoteList({
          page: 1,
          pageSize: 8,
          order,
          type,
        })
        this.promoteList = data.list
      },
      // 跳转到业务提升
      checkAllPromote () {
        let order = ''
        let type = ''
        let filter = this.promoteFilters[this.promoteFilterIndex]
        if (filter.isOrder) {
          order = filter.value
        } else {
          type = filter.type
        }
        this.$router.push(`/records?order=${order}&type=${type}`)
      },
    },
    // 市场拓展
    ...{
      // 获取市场拓展过滤标签
      async getExpandFilters () {
        const data = await api.getExpandFilter()
        this.expandFilters = data.slice(0, MAX_CARD_NUM)
        this.expandFilters.unshift({
          name: '推荐',
          value: 3,
          isOrder: true,
        })
        this.expandFilters.unshift({
          name: '最新',
          value: 1,
          isOrder: true,
        })
      },
      // 选择市场拓展标签
      selectExpandFilters (index) {
        this.expandFilterIndex = index
        this.getExpandList()
      },
      // 获取市场拓展列表
      async getExpandList () {
        let order = null
        let id = null
        let filter = this.expandFilters[this.expandFilterIndex]
        if (filter.isOrder) {
          order = filter.value
        } else {
          id = filter.id
        }
        const data = await api.getExpandList({
          page: 1,
          pageSize: 8,
          status: 1,
          marketExpansionTypeId: id,
          orderBy: order,
        })
        this.expandList = data.list
      },
      // 跳转到市场拓展
      checkAllExpand () {
        let order = ''
        let type = ''
        let filter = this.expandFilters[this.expandFilterIndex]
        if (filter.isOrder) {
          order = filter.value
        } else {
          type = filter.id
        }
        this.$router.push(`/expand?order=${order}&type=${type}`)
      },
    },
  },
  async mounted () {
    this.getBannerData()
    await this.getPromoteFilters()
    await this.getPromoteList()
    await this.getExpandFilters()
    await this.getExpandList()
  },
}
</script>

<style lang="scss" scoped>
.index {
  width: 1200px;
  margin-inline: auto;
  padding: 24px 0 120px;
  &__banner {
    height: 250px;
    background-image: url('/img/index-banner.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 64px 60px;
    box-sizing: border-box;
    margin-bottom: 52px;
    h1 {
      font-size: 34px;
      font-family: MiSans-Semibold, MiSans;
      font-weight: 600;
      color: #333333;
      line-height: 46px;
      margin: 0 0 20px;
    }
    .banner {
      &__datas {
        display: flex;
      }
      &__data {
        margin-right: 50px;
      }
      &__num {
        font-size: 20px;
        font-family: MiSans-Bold, MiSans;
        font-weight: bold;
        color: #FA8919;
        line-height: 27px;
        margin-bottom: 4px;
      }
      &__desc {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 17px;
      }
    }
  }
  &__block {
    &:last-of-type {
      margin-top: 60px;
    }
    .block {
      &__title {
        font-size: 28px;
        font-weight: 600;
        color: #333333;
        line-height: 40px;
      }
      &__desc {
        margin-block: 8px 32px;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        letter-spacing: 0.8px;
      }
      &__filter-wrapper {
        display: flex;
        justify-content: space-between;
        height: 44px;
        padding: 4px;
        box-sizing: border-box;
        background: #F0F1F2;
        margin-bottom: 24px;
        border-radius: 8px;
      }
      &__filter {
        display: flex;
      }
      &__filter-item {
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 14px;
        color: #666666;
        border-radius: 6px;
        padding-inline: 16px;
        cursor: pointer;
        &:hover {
          color: #333333;
          &.block__filter-item--active {
            color: #FFFFFF;
          }
        }
        &--active {
          font-weight: 500;
          color: #FFFFFF;
          background: #FA8919;
        }
        &:not(:last-of-type) {
          margin-right: 4px;
        }
      }
      &__all {
        margin-right: -4px;
        .ivu-icon {
          position: relative;
          top: -2px;
        }
      }
      &__cards-wrapper {
        position: relative;
        min-height: 300px;
      }
      &__cards {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 24px;
      }
      &__card {
        /deep/ .ivu-poptip, /deep/ .ivu-poptip-rel {
          display: block;
        }
      }
    }
  }
}
</style>
